import React, { useState, useEffect } from 'react';
import { CFCProps } from 'types';
import { Modal, TextInput } from 'carbon-components-react';
import { connect } from 'react-redux';
import { FormError } from 'components';

export const SendToOtherModal: React.FC<Props> = ({
  onModalClose,
  isModalOpen,
  onClickSend
}) => {
  const [disableSendButton, setDisableSendButton] = useState<boolean>(true);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [fieldValue, setFieldValue] = useState<string>('');
  const [touched, setTouched] = useState<boolean>(false);

  useEffect(() => {
    if (touched && errorMessage === '') {
      setDisableSendButton(false);
    } else {
      setDisableSendButton(true);
    }
  }, [errorMessage, touched]);

  const validate = (values?: any) => {
    setErrorMessage('');
    if (!values) {
      setErrorMessage('Required');
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values)) {
      setErrorMessage('Invalid email address');
    }
  };

  const resetForm = () => {
    setErrorMessage('');
    setFieldValue('');
    setTouched(false);
    setDisableSendButton(true);
    onModalClose();
  };

  const submitForm = () => {
    onClickSend(fieldValue);
    resetForm();
  };

  const handleOnChange = (val: any) => {
    setTouched(true);
    setFieldValue(val.target.value);
    validate(val.target.value);
  };

  return (
    <div className="send-to-other-modal">
      <Modal
        className="modal--wrapper"
        data-testid="sendToOtherModal"
        modalLabel=""
        open={isModalOpen}
        modalHeading="Send to other"
        onRequestClose={() => resetForm()}
        primaryButtonText={'Send'}
        secondaryButtonText={'Cancel'}
        onRequestSubmit={() => submitForm()}
        primaryButtonDisabled={disableSendButton}
      >
        <div>
          <div className={'modal-content-description'}>
            Please enter an email address to send the selected item
          </div>
          <div>
            <TextInput
              id="email"
              name="email"
              labelText="Email"
              type="email"
              data-testid="emailModal"
              onChange={(val) => handleOnChange(val)}
              value={fieldValue}
            />
            {errorMessage !== '' && <FormError>{errorMessage}</FormError>}
          </div>
        </div>
      </Modal>
    </div>
  );
};

const connector = connect();

type OwnProps = {
  onModalClose: Function;
  isModalOpen: boolean;
  onClickSend: Function;
};

type Props = CFCProps<typeof connector> & OwnProps;

export default React.memo(connector(SendToOtherModal));
